import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'a[appPreventDefault]'
})
export class PreventDefaultDirective {

  @HostListener('click', ['$event']) onClick(event: Event): void {
    event.preventDefault();
  }

}
